// src/api/quizBooleanApi.js

// Fetches a list of boolean quiz questions from the server.
// Returns the first 10 quiz items if successful, or an empty array if an error occurs.
export const fetchBooleanQuizzes = async () => {
  try {
    // Send GET request to the quiz API endpoint
    const response = await fetch(
      "https://zg3olhj6ke.execute-api.us-east-1.amazonaws.com/quiz/boolean",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Check if the response is OK (status 200–299)
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    // Parse JSON and extract quiz data
    const data = await response.json();

    // Return the first 10 quiz items (if available)
    return (data.quizzes || []).slice(0, 10);
  } catch (error) {
    // Log error and return empty array on failure
    console.error("Error fetching boolean quizzes:", error);
    return [];
  }
};
